import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {
    Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import iptrackerdetails from '../../../iptrackerdetails'

// import Multiselect from 'vue-multiselect'
// import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
    name: 'userstatuslist',
    components: {
        Paginate,
        VueElementLoading
    },
    data: function() {
        return {
            isLoading: false,
            pageno: 0,
            pagecount: 0,
            listStatusData:[],
            statusname:"",
            threshold:"",
            frequency:"per day",
            isvisble:true,
            editstatusname:"",
            editthreshold:"",
            editfrequency:"per day",
            editisvisble:"",
            resultCount: '',
            incrementResultCount: '',
            localuserid:'',
            localusermailid:'',
            editid:null,
            erroreditthreshold:'',
            searchstatusname:'',
            showaddbtn:false,
            iptrackData:'',
        }
    },
    created: function() {

    },
    async mounted() {
        var userdetailEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');

        const permissionEncrypt = window.localStorage.getItem('permissiondata')
			  const bytesnew = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
			  const plaintextnew = bytesnew.toString(CryptoJS.enc.Utf8);
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);


        this.iptrackData = userdetail
        console.log("this.iptrackData",this.iptrackData);
        let iptrck= await iptrackerdetails.checkUserIPV2(this.iptrackData,'Users Status List',this.$route.path);
        console.log(iptrck);
        if(iptrck){
          this.$router.push('/');
        }

        this.localuserid = userdetail.userid;
        this.localusermailid = userdetail.email;
        this.pagecount =1;
        this.getstatusData();
        
        let addstatusrestrictioncheck=plaintextnew.search("addstatusrestriction");
        if(addstatusrestrictioncheck!=-1){
          this.showaddbtn=true
        }
    },
    methods: {

      searchStatusData(){
        this.pageno = 0;
        this.$refs.paginate.selected = 0;
        this.getstatusData();
      },
      resetSearch(){
        this.searchstatusname='';
        this.pageno = 0;
        this.$refs.paginate.selected = 0;
        this.getstatusData();
      },

        getstatusData() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
      
            this.input = ({
              offset: this.pageno,
              limit: 10,
              statusname:this.searchstatusname,
              });
            this.isLoading = true;
            axios({
              method: "POST",
              url: apiUrl.api_url + "liststatusrestriction ",
              data: this.input,
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
      
            }).then(
              result => {
                this.listStatusData = result.data.data;
                this.isLoading = false;
                let totalRows = result.data.count;
                this.resultCount = result.data.count;
                this.incrementResultCount = result.data.count + 1;
                this.weightage=this.incrementResultCount;
                if (totalRows < 10) {
                  this.pagecount = 1;
                } else {
                  this.pagecount = Math.ceil(totalRows / 10);
                }
              },
              error => {
                console.error(error);
              }
            );
          },
        Updatestatus(data){
          this.erroreditthreshold="";
            this.editid=data._id;
            this.editstatusname=data.name;
            this.editthreshold=data.threshold;
            this.editfrequency=data.frequency;
            this.editisvisble=data.isvisble;
            this.$refs['editpopup'].show();
        },
        getPaginationData(pageNum) {
            this.pageno = (pageNum - 1) * 10
            this.getstatusData()
        },
        addpopupclose(){
            this.$refs['addpopup'].hide();  
            this.$validator.reset();
            this.resetform();          
        },
        editpopupclose(){
          this.editid="";
          this.editstatusname="";
          this.editthreshold="";
          this.editfrequency="per day";
          this.editisvisble="";
          this.$validator.reset();
          this.$refs['editpopup'].hide();
        },
        onSubmit: function(event) {
          this.$validator.validate('statusname').then((snameres) =>{
            if(!snameres){
              return false;
            }
          }); 
          this.$validator.validate('threshold').then((thresholdres) =>{
            if(!thresholdres){
              return false;
            }
          }); 
          this.$validator.validate('frequency').then((frequencyres) =>{
            if(!frequencyres){
              return false;
            }
          }); 
           this.$validator.validate('statusname').then((snameres) =>{
              if(!snameres){
                return false;
              }else{
                this.$validator.validate('threshold').then((thresholdres) =>{
                  if(!thresholdres){
                    return false;
                  }else{
                    this.$validator.validate('frequency').then((frequencyres) =>{
                      if(!frequencyres){
                        return false;
                      }else{
                        var userToken = window.localStorage.getItem('userToken')
                        var myStr = userToken.replace(/"/g, '');
                        let reqpayload = ({
                            name: this.statusname.trim(),
                            threshold: this.threshold.trim(),
                            frequency: this.frequency,
                            isvisble: this.isvisble,
                            createdby: this.localusermailid
                        })                                   
                        axios({
                            method: "POST",
                            url: apiUrl.api_url + "insertstatusrestriction",
                            'data': reqpayload,
                            headers: {
                                'Authorization': 'Bearer ' + myStr
                            }
                            })
                            .then(response => {
                              console.log(response);
                            if (response.data.code == 200) {
                                this.$alertify.success(response.data.message);
                                this.$refs['addpopup'].hide();                         
                                this.resetform();
                            }else if (response.data.code == 204) {
                                this.$alertify.error(response.data.message);                        
                            }else {
                                this.$alertify.error(response.data.message);
                                this.$refs['addpopup'].hide(); 
                                this.resetform();
                            }
                            })
                            .catch(httpException => {
                            console.error("exception is:::::::::", httpException);
                            });
                      }
                    });
                  }
                });
              }
           });           
          },

          onUpdateSubmit(){
                    if(this.editthreshold==""){
                        this.erroreditthreshold="Threshold Field is required";
                        return false;
                    }
                    if(this.editthreshold<0){
                      this.erroreditthreshold="The threshold field must be 0 or more.";
                      return false;
                  }
                    this.erroreditfrequency="per day";
                                    
                  var userToken = window.localStorage.getItem('userToken')
                  var myStr = userToken.replace(/"/g, '');
                  let reqpayload = ({
                      id:this.editid,
                      threshold: this.editthreshold,
                      modifiedby: this.localusermailid
                  })
                                       
                  axios({
                      method: "POST",
                      url: apiUrl.api_url + "updatestatusrestriction",
                      'data': reqpayload,
                      headers: {
                          'Authorization': 'Bearer ' + myStr
                      }
                      })
                      .then(response => {
                      if (response.data.code == 200) {
                          this.$alertify.success(response.data.message);
                          this.$refs['editpopup'].hide(); 
                          this.resetform();
                          this.$validator.reset();
                          this.getstatusData();
                         // window.location.reload();
                      }else if (response.data.code == 209) {
                          this.$alertify.error(response.data.message);                        
                      }else {
                          this.$alertify.error(response.data.message);
                          this.$refs['editpopup'].hide();  
                          this.getstatusData();
                          this.resetform();
                          this.$validator.reset();
                          //window.location.reload();
                      }
                     // iptrackerdetails.checkUserIP(this.iptrackData,'Add Status',this.$route.path,reqpayload,response.data);
  
                      })
                      .catch(httpException => {
                      console.error("exception is:::::::::", httpException);
                      });
          },
          isIntegerOnly(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (charCode < 48 || charCode > 57 || this.threshold.length>9 || this.editthreshold.length>9 ) {
              evt.preventDefault();
            }
            else {
              return true;
            }
          },
          resetform() {
            this.statusname = "";
            this.threshold = "";
            this.frequency = "per day";
            this.isvisble=true;
            this.editstatusname="";
            this.editthreshold="";
            this.editfrequency="per day";
            this.editisvisble="";
            this.$validator.reset();
            this.getstatusData();
          },
    },
}




// WEBPACK FOOTER //
// ./src/views/components/userstatuslist/userstatuslist.component.js